export const Data = [
  {
    id: '1',
    name: 'Dropshipping Platform',
    description: 'MERN commerce platform with JWT authentication, cart and product management, automated emails, and role-based admin and seller dashboards.',
    tags: ['MERN', 'JWT', 'E-commerce'],
    link: 'https://github.com/MuhammadSarimWaseem/E-Commerce'
  },
  {
    id: '2',
    name: 'CopyRank',
    description: 'AI-powered SEO platform that analyzes websites, researches keywords, generates articles, manages subscriptions, and publishes directly to WordPress and Framer.',
    tags: ['Next.js', 'Supabase', 'AI'],
    link: 'https://copyrank.ai/',
    featured: true
  },
  {
    id: '3',
    name: 'Mortgage Financial Arena',
    description: 'AI social media platform for mortgage brokers with responsive workflows, authentication, REST API integrations, testing, and performance improvements.',
    tags: ['React', 'REST API', 'AI'],
    link: 'https://mortgagesocial.co.uk/',
    featured: true
  },
  {
    id: '4',
    name: 'Stafftrackerfb',
    description: 'Automated CI/CD pipeline designed and implemented to make project builds and deployments faster, repeatable, and more dependable.',
    tags: ['CI/CD', 'Automation', 'Deployment'],
    link: 'https://football-coaching-ui.vercel.app/'
  },
  {
    id: '5',
    name: 'Boldfusion',
    description: 'Custom backend for fetching and managing WordPress ACF data, integrated with a purpose-built frontend and deployed through CyberPanel.',
    tags: ['WordPress', 'Backend', 'CyberPanel'],
    link: 'https://boldfusion.ae/'
  },
  {
    id: '6',
    name: 'Artful Swipe',
    description: 'Full-stack product discovery platform featuring 2,300+ products, Supabase authentication, favorites, value tracking, analytics, and role-based dashboards.',
    tags: ['React', 'Supabase', 'Analytics'],
    link: 'https://artful-swipe-discover.vercel.app/',
    featured: true
  },
  {
    id: '7',
    name: 'Erosa',
    description: 'WordPress ACF data backend connected to a custom frontend, with server configuration, domain setup, and full-stack CyberPanel deployment.',
    tags: ['WordPress', 'API', 'Deployment'],
    link: 'https://erosa.ae/'
  },
  {
    id: '8',
    name: 'Stripe Integration',
    description: 'Secure payment system with backend APIs and a responsive cart and checkout experience built using React, Node.js, and Stripe.',
    tags: ['React', 'Node.js', 'Stripe'],
    link: 'https://github.com/MuhammadSarimWaseem/Stripe-Integration'
  }
];
